import * as Sentry from '@sentry/react';
import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { routes } from "../constants";
import { createStore } from "./createStore";
import { Provider } from "./store-context";
import { useIoContext } from "../providers/IoContext";
export function StoreProvider(props) {
  const {
    children,
    mgmtHost,
    pdfHost,
    apiGatewayHost,
    apiHost,
    authDomain,
    useAuthorizationHeader = false,
    initialState,
    sessionTimeoutMS,
    initStoreApi
  } = props;
  const history = useHistory();
  const {
    getIntercom,
    getNow,
    slackClient,
    cookies,
    logBIEvent
  } = useIoContext();
  const store = useMemo(() => createStore({
    initialState: initialState || {},
    session: {
      mgmtHost,
      apiGatewayHost,
      apiHost,
      pdfHost,
      authDomain,
      useAuthorizationHeader,
      sessionTimeoutMS
    },
    onLogout: () => history.push(routes.logout),
    getNow,
    getIntercom,
    initStoreApi,
    getCookie: () => cookies.getCookie(),
    onCookieChange: () => cookies.trySignalAuthTokenChange(),
    slackClient,
    reportToSentry: function reportToSentry(message) {
      let {
        context
      } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      Sentry.withScope(scope => {
        if (context) {
          Object.entries(context).forEach(_ref => {
            let [key, value] = _ref;
            scope.setContext(key, value);
          });
        }
        Sentry.captureException(new Error(message));
      });
    },
    onLogBI: logBIEvent
  }),
  // eslint-disable-next-line react-hooks-static-deps/exhaustive-deps
  []);
  return /*#__PURE__*/React.createElement(Provider, {
    value: store
  }, children);
}